import * as ngrxSignals from "@ngrx/signals";
import * as ngrxSignalsRxjsInterop from "@ngrx/signals/rxjs-interop";
import * as ngrxSignalsEvents from "@ngrx/signals/events";
import * as ngrxSignalsEntities from "@ngrx/signals/entities";
const ngrx = window["@ngrx"] || {};
ngrx.signals = {
  core: ngrxSignals,
  rxjsInterop: ngrxSignalsRxjsInterop,
  events: ngrxSignalsEvents,
  entities: ngrxSignalsEntities,
};
window["@ngrx"] = ngrx;
export {
  ngrxSignals,
  ngrxSignalsRxjsInterop,
  ngrxSignalsEvents,
  ngrxSignalsEntities,
};
